export const ACKO_LOGO_HORIZONTAL_GRADIENT_DARK = 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg'
export const ACKO_LOGO_HORIZONTAL_GRADIENT_WHITE = 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/horizontal-reverse.svg'

export const getAckoLogo = (darkMode: boolean) =>
    darkMode ? ACKO_LOGO_HORIZONTAL_GRADIENT_WHITE : ACKO_LOGO_HORIZONTAL_GRADIENT_DARK
